import React, { useState } from "react";
import {
  Card,
  CardHeader,
  CardBody,
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Button,
  Row,
  Col,
} from "reactstrap";
import classnames from "classnames";
import { Dropdown } from "react-bootstrap";
import "../styles/Dashboard.css";
import "../styles/Apartments.css";
import axios from "axios";

const stepNavitemStyle = {
  backgroundColor: "#fcfcfc",
};

function Form() {
  const [activeStep, setActiveStep] = useState("1");
  const [formSwitch, setFormSwitch] = useState(0);
  const [fifthInput, setFifthInput] = useState(0);
  const [showMessage, setMessage] = useState("");
  const [showContact, setContact] = useState("");
  const [showContactInfo, setContactInfo] = useState("");
  const [showText, setText] = useState("");
  const [showKw, setKw] = useState("");
  const [activeForm, setActiveForm] = useState("");

  const [showRuralKw, setRuralKw] = useState(null);
  const [showUrbanKw, setUrbanKw] = useState(null);
  const [showbkFirstInput, setbkFirstInput] = useState(0);
  const [showbkSecondInput, setbkSecondInput] = useState(0);
  const [showbkFourthInput, setbkFourthInput] = useState(0);
  const [showbkFifthInput, setbkFifthInput] = useState(0);
  const [showbkSixthInput, setbkSixthInput] = useState(0);
  const [showbkFirstRadio, setbkFirstRadio] = useState(true);
  const [showbkSelect, setbkSelect] = useState("3.7");
  const [showbkSecondRadio, setbkSecondRadio] = useState(5);

  const [showngFirstInput, setngFirstInput] = useState(0);
  const [showngSecondInput, setngSecondInput] = useState(0);
  const [showngThirdInput, setngThirdInput] = useState(0);
  const [showngFourthInput, setngFourthInput] = useState(0);
  const [showngFirstRadio, setngFirstRadio] = useState(true);
  const [showngSecondRadio, setngSecondRadio] = useState(5);
  const [showFirstName, setFirstName] = useState("");
  const [showLastName, setLastName] = useState("");
  const [showEmail, setEmail] = useState("");
  const [showAddress, setAddress] = useState("");
  const [showCity, setCity] = useState("");
  const [showSt, setSt] = useState("");
  const [showPhone, setPhone] = useState("");
  const [previewsForm, setPreviewsForm] = useState("");

  const clearState = () => {
    setRuralKw(null);
    setUrbanKw(null);
    setbkFirstInput(0);
    setbkSecondInput(0);
    setbkFourthInput(0);
    setbkFifthInput(0);
    setbkSixthInput(0);
    setbkFirstRadio(true);
    setbkSelect("3.7");
    setbkSecondRadio(5);
    setngFirstInput(0);
    setngSecondInput(0);
    setngThirdInput(0);
    setngFourthInput(0);
    setngFirstRadio(true);
    setngSecondRadio(5);
    setSelectedOption(options[0].num);
    setMessage("");
    setFifthInput(0);
    setContactInfo("");
    setContact("");
    setText("");
    setKw("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setAddress("");
    setCity("");
    setSt("");
    setPhone("");
    setPreviewsForm("");
  };

  function calculationNg() {
    let a = 0;
    let b = 0;
    let c = 0;
    let urbanOrRural = 0;
    let d = 0;
    let bodrumet = 0;
    let pompat = 0;
    let e = 0;
    let y = 0;
    let res = 0;

    if (showUrbanKw == null) {
      urbanOrRural = showRuralKw;
      d = 2.5;
    } else {
      urbanOrRural = showUrbanKw;
      d = 1.52;
    }

    if (showngFirstRadio) {
      a = parseInt(showngFirstInput) + parseInt(showngSecondInput);
      b = urbanOrRural * a;
      c = d * b + b;
    } else if (showngFirstRadio == false) {
      a = parseInt(showngFirstInput) + parseInt(showngSecondInput);
      c = urbanOrRural * a;
    }

    bodrumet = 0.5 * parseInt(showngThirdInput);
    pompat = 5 * parseInt(showngFourthInput);
    e = c + bodrumet + pompat + showngSecondRadio;
    y = e * 1.1;
    res = y * 1.05;
    var final = parseFloat(res).toFixed(2);
    return final;
  }

  function calculationNgForCondition() {
    let res = 0;
    res = calculationNg();
    var final = res * 1.2;
    return final;
  }

  function calculationBk() {
    let a = 0;
    let b = 0;
    let c = 0;
    let urbanOrRural = 0;
    let d = 0;
    let bodrumet = 0;
    let ashensori = 0;
    let pompat = 0;
    let e = 0;
    let y = 0;
    let res = 0;

    if (showUrbanKw == null) {
      urbanOrRural = showRuralKw;
      d = 2.5;
    } else {
      urbanOrRural = showUrbanKw;
      d = 1.52;
    }

    if (showbkFirstRadio) {
      a = parseInt(showbkFirstInput) + parseInt(showbkSecondInput);
      b = urbanOrRural * a;
      c = d * b + b;
    } else if (showbkFirstRadio == false) {
      a = parseInt(showbkFirstInput) + parseInt(showbkSecondInput);
      c = urbanOrRural * a;
    }

    bodrumet = 5 * parseInt(showbkFourthInput);
    ashensori = parseInt(showbkFifthInput) * parseFloat(showbkSelect);
    pompat = 5 * parseInt(showbkSixthInput);
    e = c + bodrumet + ashensori + pompat + showbkSecondRadio;
    y = e * 1.1;
    res = y * 1.05;

    var final = parseFloat(res).toFixed(2);

    return final;
  }

  function calculationBkForCondition() {
    let res = 0;
    res = calculationBk();
    var final = res * 1.2;
    return final;
  }

  const toggleStep = (step) => {
    if (activeStep !== step) {
      setActiveStep(step);
    }
  };

  const onDelete = () => {
    clearState();
    setActiveStep("1");
  };

  const switchForm = (content) => {
    setFormSwitch(content);
    setActiveStep("2");
  };

  const recommend = (myTotal, shouldReturn = false) => {
    if (myTotal >= 2490) {
      lastCondition(myTotal, shouldReturn);
    } else {
      firstconditions(myTotal, false, shouldReturn);
    }
  };

  function firstconditions(
    parameter,
    shouldSeparate = false,
    shouldReturn = false
  ) {
    if (parameter > 1 && parameter < 50) {
      if (shouldReturn) return shouldSeparate ? "2 x 50" : "50";
      shouldSeparate ? setText("2 x 50") : setText("50");
    } else if (parameter >= 50 && parameter < 100) {
      if (shouldReturn) return shouldSeparate ? "2 x 100" : "100";
      shouldSeparate ? setText("2 x 100") : setText("100");
    } else if (parameter >= 100 && parameter < 160) {
      if (shouldReturn) return shouldSeparate ? "2 x 160" : "160";
      shouldSeparate ? setText("2 x 160") : setText("160");
    } else if (parameter >= 160 && parameter < 250) {
      if (shouldReturn) return shouldSeparate ? "2 x 250" : "250";
      shouldSeparate ? setText("2 x 250") : setText("250");
    } else if (parameter >= 250 && parameter < 400) {
      if (shouldReturn) return shouldSeparate ? "2 x 400" : "400";
      shouldSeparate ? setText("2 x 400") : setText("400");
    } else if (parameter >= 400 && parameter < 630) {
      if (shouldReturn) return shouldSeparate ? "2 x 630" : "630";
      shouldSeparate ? setText("2 x 630") : setText("630");
    } else if (parameter >= 630 && parameter < 1000) {
      if (shouldReturn) return shouldSeparate ? "2 x 1000" : "1000";
      shouldSeparate ? setText("2 x 1000") : setText("1000");
    } else if (parameter >= 1000 && parameter < 1250) {
      if (shouldReturn) return shouldSeparate ? "2 x 1250" : "1250";
      shouldSeparate ? setText("2 x 1250") : setText("1250");
    } else if (parameter >= 1250 && parameter < 1600) {
      if (shouldReturn) return shouldSeparate ? "2 x 1600" : "1600";
      shouldSeparate ? setText("2 x 1600") : setText("1600");
    } else if (parameter >= 1600 && parameter < 2000) {
      if (shouldReturn) return shouldSeparate ? "2 x 2000" : "2000";
      shouldSeparate ? setText("2 x 2000") : setText("2000");
    } else if (parameter >= 2000 && parameter < 2500) {
      if (shouldReturn) return shouldSeparate ? "2 x 2500" : "2500";
      shouldSeparate ? setText("2 x 2500") : setText("2500");
    }
  }

  function lastCondition(currTotal, shouldReturn) {
    let newResult = 0;
    if (currTotal >= 2490) {
      newResult = currTotal / 2;
      firstconditions(newResult, true, shouldReturn);
    }
  }

  const options = [
    {
      val: "Banim kolektiv",
      num: 1,
      html: (
        <div>
          <div className="form-inputs">
            <label className="form-label"> Numri i banesave:</label>
            <input
              required
              value={showbkFirstInput}
              onChange={(event) => setbkFirstInput(event.target.value)}
              className="form-input"
              name="banesat"
              type="number"
            />
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i lokaleve:</label>
            <input
              required
              value={showbkSecondInput}
              onChange={(event) => setbkSecondInput(event.target.value)}
              className="form-input"
              name="lokalet"
              type="number"
            />
          </div>
          <div
            className="form-inputs"
            style={{ fontSize: "13px", color: "#777777" }}
          >
            <label className="form-label">A ka nxemje me rrymë?</label>
            <br></br>
            <input
              type="radio"
              className="radio-button"
              value="Po"
              checked={showbkFirstRadio == true}
              name="yesno"
              onChange={(e) => setbkFirstRadio(e.target.value ? true : false)}
            />{" "}
            Po
            <input
              style={{ marginLeft: "30px" }}
              type="radio"
              value="Jo"
              className="radio-button"
              checked={showbkFirstRadio == false}
              name="yesno"
              onChange={() => setbkFirstRadio(false)}
            />{" "}
            Jo
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i bodrumeve:</label>
            <input
              required
              value={showbkFourthInput}
              onChange={(event) => setbkFourthInput(event.target.value)}
              className="form-input"
              name="bodrumet"
              type="number"
            />
          </div>
          <div className="form-inputs" style={{ marginTop: "20px" }}>
            <label className="form-label">Lloji i ashensorit në kg:</label>
            <select
              value={showbkSelect}
              required
              className="form-input"
              name="ashensoret"
              onChange={(event) => setbkSelect(event.target.value)}
            >
              <option style={{ fontSize: "14px" }} value="3.7">
                500-600
              </option>
              <option style={{ fontSize: "14px" }} value="4.6">
                600-800
              </option>
              <option style={{ fontSize: "14px" }} value="9.7">
                800-1000
              </option>
              <option style={{ fontSize: "14px" }} value="11">
                1000-1100
              </option>
            </select>
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i ashensorëve:</label>
            <input
              required
              value={showbkFifthInput}
              onChange={(event) => setbkFifthInput(event.target.value)}
              className="form-input"
              name="nrashensoreve"
              type="number"
            />
          </div>
          <div
            className="form-inputs"
            style={{ fontSize: "13px", color: "#777777" }}
          >
            <label className="form-label">A ka ndriqim publik?</label>
            <br></br>
            <input
              type="radio"
              value="Po"
              checked={showbkSecondRadio == 5}
              name="yesno1"
              onChange={(e) => setbkSecondRadio(e.target.value ? 5 : 0)}
            />{" "}
            Po
            <input
              style={{ marginLeft: "30px" }}
              type="radio"
              value="Jo"
              checked={showbkSecondRadio == 0}
              name="yesno1"
              onChange={() => setbkSecondRadio(0)}
            />{" "}
            Jo
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i pompave të ujit:</label>
            <input
              required
              value={showbkSixthInput}
              onChange={(event) => setbkSixthInput(event.target.value)}
              className="form-input"
              name="pompat"
              type="number"
            />
          </div>
        </div>
      ),
    },
    {
      val: "Lagje",
      num: 2,
      html: (
        <div>
          <div className="form-inputs">
            <label className="form-label"> Numri i shtëpive:</label>
            <input
              required
              onChange={(event) => setngFirstInput(event.target.value)}
              className="form-input"
              value={showngFirstInput}
              name="nrBanesaveL"
              type="number"
            />
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i lokaleve:</label>
            <input
              required
              value={showngSecondInput}
              onChange={(event) => setngSecondInput(event.target.value)}
              className="form-input"
              name="nrLokaleveL"
              type="number"
            />
          </div>
          <div
            className="form-inputs"
            style={{ fontSize: "13px", color: "#777777" }}
          >
            <label className="form-label">A ka nxemje me rrymë?</label>
            <br></br>
            <input
              type="radio"
              value="true"
              checked={showngFirstRadio == true}
              name="ngYesNo"
              onChange={(e) => setngFirstRadio(e.target.value ? true : false)}
            />{" "}
            Po
            <input
              style={{ marginLeft: "30px" }}
              type="radio"
              value="false"
              checked={showngFirstRadio == false}
              name="ngYesNo"
              onChange={() => setngFirstRadio(false)}
            />{" "}
            Jo
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i bodrumeve:</label>
            <input
              required
              value={showngThirdInput}
              onChange={(event) => setngThirdInput(event.target.value)}
              className="form-input"
              name="nkBodrumeveL"
              type="number"
            />
          </div>
          <div
            className="form-inputs"
            style={{ fontSize: "13px", color: "#777777" }}
          >
            <label className="form-label">A ka ndriqim publik?</label>
            <br></br>
            <input
              id="ngNdriqimi"
              type="radio"
              value="Po"
              checked={showngSecondRadio == 5}
              name="yesno1L"
              onChange={(e) => setngSecondRadio(e.target.value ? 5 : 0)}
            />{" "}
            Po
            <input
              style={{ marginLeft: "30px" }}
              id="ngNdriqimi"
              type="radio"
              value="Jo"
              checked={showngSecondRadio == 0}
              name="yesno1L"
              onChange={() => setngSecondRadio(0)}
            />{" "}
            Jo
          </div>
          <div className="form-inputs">
            <label className="form-label">Numri i pompave të ujit:</label>
            <input
              required
              value={showngFourthInput}
              onChange={(event) => setngFourthInput(event.target.value)}
              className="form-input"
              name="sisPompimitL"
              type="number"
            />
          </div>
        </div>
      ),
    },
  ];
  const [selectedOption, setSelectedOption] = useState(options[0].num);
  const handleSelectChange = (e) => {
    const currentVal = e.target.value;
    const currentOpt = options.find((opt) => opt.val === currentVal);
    setSelectedOption(currentOpt.num);
  };

  function elevetatorType() {
    if (showbkSelect === "3.7") {
      return "500-600";
    } else if (showbkSelect === "4.6") {
      return "600-800";
    } else if (showbkSelect === "9.7") {
      return "800-1000";
    } else {
      return "1000-1100";
    }
  }

  const dataForAxios = async () => {
    try {
      const ruralOrUrbanBtn = showRuralKw == 2.1 ? "Rurale" : "Urbane";
      const buttonClicked =
        showRuralKw == null && showUrbanKw == null
          ? "Industri"
          : ruralOrUrbanBtn;

      const typeOfHousing = selectedOption == 1 ? "Banim Kolektiv" : "Lagje";

      const houseOrApartament = selectedOption == 1 ? " Banesa" : " Shtepi";
      const numberOfHousesOrApartaments =
        selectedOption == 1 ? showbkFirstInput : showngFirstInput;
      const numberOfUnits = numberOfHousesOrApartaments + houseOrApartament;

      const numberOfPremises =
        selectedOption == 1 ? showbkSecondInput : showngSecondInput;

      const electricHeatingBK = showbkFirstRadio == true ? "Po" : "Jo";
      const electricHeatingNG = showngFirstRadio == true ? "Po" : "Jo";
      const heating =
        selectedOption == 1 ? electricHeatingBK : electricHeatingNG;

      const cellars =
        selectedOption == 1 ? showbkFourthInput : showngThirdInput;

      const elevetorT =
        selectedOption == 1 ? elevetatorType() : "Nuk ka ashensor";

      const numberOfElevators =
        selectedOption == 1 ? showbkFifthInput : "Nuk ka ashensor";

      const publicLightingBK = showbkSecondRadio == 5 ? "Po" : "Jo";
      const publicLightingNB = showngSecondRadio == 5 ? "Po" : "Jo";
      const lighting =
        selectedOption == 1 ? publicLightingBK : publicLightingNB;

      const pumps = selectedOption == 1 ? showbkSixthInput : showngFourthInput;

      const power = fifthInput;

      let dependingTotal = 0;
      if (buttonClicked === "Industri") {
        dependingTotal = (parseInt(fifthInput) * 0.846).toFixed(2);
      } else if (buttonClicked === "Rurale" || buttonClicked === "Urbane") {
        selectedOption == 1
          ? (dependingTotal = calculationBk())
          : (dependingTotal = calculationNg());
      }

      let dependingRcm = 0;
      if (buttonClicked === "Industri") {
        dependingRcm = showText;
      } else if (buttonClicked === "Rurale" || buttonClicked === "Urbane") {
        dependingRcm = showText;
      }

      const objK = {
        first_name: showFirstName,
        last_name: showLastName,
        email: showEmail,
        address_line_1: showAddress,
        city: showCity,
        state: showSt,
        phone: showPhone,
        zona: buttonClicked,
        total_kw: dependingTotal,
        rekomanduar: dependingRcm,
      };
      if (buttonClicked !== "Industri") {
        if (selectedOption == 1) {
          objK["lloji_i_banimit"] = typeOfHousing;
          objK["numri_i_njesive"] = numberOfUnits;
          objK["numri_i_lokaleve"] = numberOfPremises;
          objK["nxemje_me_rryme"] = heating;
          objK["numri_i_bodrumev"] = cellars;
          objK["lloji_i_ashensor"] = elevetorT;
          objK["numri_i_ashensor"] = numberOfElevators;
          objK["ndriqim_publik"] = lighting;
          objK["numri_i_pompave_"] = pumps;
        } else if (selectedOption == 2) {
          objK["lloji_i_banimit"] = typeOfHousing;
          objK["numri_i_njesive"] = numberOfUnits;
          objK["numri_i_lokaleve"] = numberOfPremises;
          objK["nxemje_me_rryme"] = heating;
          objK["numri_i_bodrumev"] = cellars;
          objK["ndriqim_publik"] = lighting;
          objK["numri_i_pompave_"] = pumps;
        }
      } else if (buttonClicked === "Industri") {
        objK["fuqia_e_shenuar_"] = power;
      }

      const response = await axios.post(
        `https://europesys.com/wp-admin/?fluentcrm=1&route=contact&hash=4f9f5105-fab8-4768-b474-112ad4b40e3c`,
        objK,
        {
          headers: {
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      return response;
    } catch (error) {}
  };

  return (
    <Card className="card-default" style={{ width: "100%" }}>
      <CardHeader>KALKULATORI</CardHeader>

      <CardBody>
        <Row id="column-content">
          <Col className="col-12 col-lg-4">
            <Nav pills vertical={true}>
              <NavItem style={stepNavitemStyle}>
                <NavLink
                  tag="div"
                  className={classnames({
                    active: activeStep === "1",
                  })}
                  onClick={() => {
                    toggleStep("1");
                  }}
                >
                  <h4
                    className="text-left my-3"
                    id="nav-h"
                    style={{ fontSize: "16px" }}
                  >
                    1. Zgjedh hapsirën
                  </h4>
                </NavLink>
              </NavItem>
              <NavItem style={stepNavitemStyle} id="first-nav">
                <NavLink
                  tag="div"
                  className={classnames({
                    active: activeStep === "2",
                  })}
                >
                  <h4
                    className="text-left my-3"
                    id="nav-h"
                    style={{ fontSize: "16px" }}
                  >
                    2. Përcakto Parametrat
                  </h4>
                </NavLink>
              </NavItem>
              <NavItem style={stepNavitemStyle} id="first-nav">
                <NavLink
                  tag="div"
                  className={classnames({
                    active: activeStep === "3",
                  })}
                >
                  <h4
                    className="text-left my-3"
                    id="nav-h"
                    style={{ fontSize: "16px" }}
                  >
                    3. Të dhënat e juaja
                  </h4>
                </NavLink>
              </NavItem>
              <NavItem style={stepNavitemStyle} id="first-nav">
                <NavLink
                  tag="div"
                  className={classnames({
                    active: activeStep === "4",
                  })}
                >
                  <h4
                    className="text-left my-3"
                    id="nav-h"
                    style={{ fontSize: "16px" }}
                  >
                    4. Trasnformatori i rekomanduar
                  </h4>
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col className="col-12 col-lg-8">
            <TabContent activeTab={activeStep} className="border-0">
              <TabPane tabId="1" style={{ height: "270px" }}>
                <div
                  style={{
                    alignItems: "center",
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    height: "250px",
                  }}
                >
                  <p
                    style={{
                      fontSize: "13px",
                      color: "#595959",
                      fontFamily: "Helvetica",
                      textAlign: "center",
                    }}
                  >
                    Ju lutem zgjedhni hapsirën, se për çfarë do të përdoret
                    transformatori
                  </p>
                  <div className="mediaq">
                    <Dropdown
                      style={{ width: "25%", height: "100%" }}
                      id="main-dropdown"
                      className="main-dropdown"
                    >
                      <Dropdown.Toggle
                        variant="success"
                        id="dropdown-basic"
                        style={{
                          fontSize: "13px",
                          width: "100%",
                          height: "100%",
                        }}
                      >
                        Zona
                      </Dropdown.Toggle>
                      <Dropdown.Menu
                        id="dropdown-menu"
                        style={{ fontSize: "13px" }}
                      >
                        <Dropdown.Item
                          id="dropdown-menu-text"
                          style={{
                            borderLeft: "3px solid #0f6fff",
                            borderRight: "3px solid #0f6fff",
                          }}
                          onClick={() => {
                            setRuralKw(2.1);
                            setUrbanKw(null);
                            switchForm(0);
                            setActiveForm("apartaments");
                          }}
                        >
                          Rurale
                        </Dropdown.Item>
                        <div
                          style={{
                            height: "0px",
                            borderTop: "0.01px solid #0f6fff",
                          }}
                        ></div>
                        <Dropdown.Item
                          id="dropdown-menu-text"
                          style={{
                            borderLeft: "3px solid #0f6fff",
                            borderRight: "3px solid #0f6fff",
                            borderBottom: "3px solid #0f6fff",
                          }}
                          onClick={() => {
                            setUrbanKw(3.42);
                            setRuralKw(null);
                            switchForm(0);
                            setActiveForm("apartaments");
                          }}
                        >
                          Urbane
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>

                    <button
                      onClick={() => {
                        switchForm(2);
                        setActiveForm("industry");
                        setUrbanKw(null);
                        setRuralKw(null);
                      }}
                      className="ind-btn"
                    >
                      Industri
                    </button>
                  </div>
                </div>
              </TabPane>
              <TabPane tabId="2">
                {formSwitch == 0 ? (
                  <form
                    id="apartaments"
                    onSubmit={(e) => {
                      e.preventDefault();
                      setMessage("Konsumi juaj i llogaritur është: ");
                      selectedOption == 1
                        ? recommend(calculationBkForCondition())
                        : recommend(calculationNgForCondition());
                      setKw(" kVA");
                      setContact(
                        "Në bazë të të dhënave të shënuara nga ju, ju rekomandojmë: "
                      );
                      setContactInfo(
                        " trafo. Për më shumë detaje dhe informacione na drejtohuni duke na kontaktuar direkt në "
                      );
                      toggleStep("3");
                      setPreviewsForm("apartaments");
                      setActiveForm("data");
                    }}
                  >
                    <div className="form-inputs">
                      <label className="form-label">Lloji i banimit:</label>
                      <br></br>

                      <select
                        value={
                          selectedOption == options[0].num
                            ? options[0].val
                            : options[1].val
                        }
                        className="form-input"
                        onChange={handleSelectChange}
                      >
                        {options.map((option) => (
                          <option
                            style={{ fontSize: "14px" }}
                            value={option.val}
                            key={option.val}
                          >
                            {option.val}
                          </option>
                        ))}
                      </select>
                    </div>
                    {selectedOption == 1 ? options[0].html : options[1].html}
                  </form>
                ) : (
                  <div>
                    <div style={{ marginTop: "60px", marginBottom: "65px" }}>
                      <form
                        id="industry"
                        onSubmit={(e) => {
                          e.preventDefault();
                          recommend(parseInt(fifthInput) * 0.846);
                          setMessage("Konsumi juaj i llogaritur është: ");
                          setKw(" kVA");
                          setContact(
                            "Në bazë të të dhënave të shënuara nga ju, ju rekomandojmë: "
                          );
                          setContactInfo(
                            " trafo. Për më shumë detaje dhe informacione na drejtohuni duke na kontaktuar direkt në "
                          );
                          setPreviewsForm("industry");
                          toggleStep("3");

                          setActiveForm("data");
                        }}
                      >
                        <label className="form-label">
                          Shkruani fuqinë në kVA:
                        </label>
                        <input
                          required
                          value={fifthInput}
                          onChange={(event) =>
                            setFifthInput(event.target.value)
                          }
                          className="form-input"
                          name="fuqia"
                          type="number"
                        />
                      </form>
                    </div>
                  </div>
                )}
                <hr />
                <div className="d-flex">
                  <Button
                    color="secondary"
                    onClick={() => {
                      toggleStep("1");
                    }}
                    style={{ fontSize: "13px" }}
                  >
                    Kthehu pas
                  </Button>

                  {formSwitch == 0 ? (
                    <Button
                      form={activeForm}
                      className="ml-auto"
                      color="primary"
                      style={{ fontSize: "13px" }}
                    >
                      Kalkulo
                    </Button>
                  ) : formSwitch === 1 ? (
                    <Button
                      form={activeForm}
                      className="ml-auto"
                      color="primary"
                      style={{ fontSize: "13px" }}
                    >
                      Kalkulo
                    </Button>
                  ) : (
                    <Button
                      form={activeForm}
                      className="ml-auto"
                      color="primary"
                      style={{ fontSize: "13px" }}
                    >
                      Kalkulo
                    </Button>
                  )}
                </div>
              </TabPane>
              <TabPane tabId="3">
                <form
                  id="data"
                  onSubmit={(e) => {
                    e.preventDefault();
                    toggleStep("4");
                  }}
                >
                  <div className="form-inputs">
                    <label className="form-label">Emri</label>
                    <input
                      required
                      onChange={(event) => setFirstName(event.target.value)}
                      className="form-input"
                      value={showFirstName}
                      name="first_name"
                      type="text"
                    />
                  </div>
                  <div className="form-inputs">
                    <label className="form-label">Mbiemri</label>
                    <input
                      required
                      onChange={(event) => setLastName(event.target.value)}
                      className="form-input"
                      value={showLastName}
                      name="last_name"
                      type="text"
                    />
                  </div>
                  <div className="form-inputs">
                    <label className="form-label">Email</label>
                    <input
                      required
                      onChange={(event) => setEmail(event.target.value)}
                      className="form-input"
                      value={showEmail}
                      name="email"
                      type="email"
                    />
                  </div>
                  <div className="form-inputs">
                    <label className="form-label">Adresa</label>
                    <input
                      required
                      onChange={(event) => setAddress(event.target.value)}
                      className="form-input"
                      value={showAddress}
                      name="address_line_1"
                      type="text"
                    />
                  </div>
                  <div className="form-inputs">
                    <label className="form-label">Qyteti</label>
                    <input
                      required
                      onChange={(event) => setCity(event.target.value)}
                      className="form-input"
                      value={showCity}
                      name="city"
                      type="text"
                    />
                  </div>

                  <div className="form-inputs">
                    <label className="form-label">Shteti</label>
                    <input
                      required
                      onChange={(event) => setSt(event.target.value)}
                      className="form-input"
                      value={showSt}
                      name="state"
                      type="text"
                    />
                  </div>
                  <div className="form-inputs">
                    <label className="form-label">Telefoni</label>
                    <input
                      required
                      onChange={(event) => setPhone(event.target.value)}
                      className="form-input"
                      value={showPhone}
                      name="phone"
                      type="number"
                    />
                  </div>

                  <hr />
                  <div className="d-flex">
                    <Button
                      form={activeForm}
                      color="secondary"
                      style={{ fontSize: "13px" }}
                      onClick={() => {
                        previewsForm === "apartaments"
                          ? setActiveForm("apartaments")
                          : setActiveForm("industry");

                        toggleStep("2");
                      }}
                    >
                      Kthehu pas
                    </Button>
                    <Button
                      form={activeForm}
                      className="ml-auto"
                      type="submit"
                      color="primary"
                      style={{ fontSize: "13px" }}
                      onClick={() => dataForAxios()}
                    >
                      Vazhdoni
                    </Button>
                  </div>
                </form>
              </TabPane>
              <TabPane tabId="4">
                <div>
                  {formSwitch == 0 || formSwitch == 3 ? (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        padding: "13px",
                      }}
                    >
                      <p className="paragraph">
                        {showMessage}
                        <b>
                          {selectedOption == 1
                            ? calculationBk()
                            : calculationNg()}
                          {showKw}
                        </b>
                      </p>
                      <p className="secondparagraph">
                        {showContact}
                        <b>{showText}</b>
                        <b>{showKw}</b>
                        {showContactInfo}
                        <a href="mailto:info@europesys.com">
                          info@europesys.com
                        </a>
                      </p>
                    </div>
                  ) : (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column",
                        padding: "13px",
                      }}
                    >
                      <p className="paragraph">
                        {showMessage}
                        {(parseInt(fifthInput) * 0.846).toFixed(2)}
                        {showKw}
                      </p>
                      <p className="secondparagraph">
                        {showContact}
                        <b>{showText}</b>
                        <b>{showKw}</b>
                        {showContactInfo}
                        <a href="mailto:info@europesys.com">
                          info@europesys.com
                        </a>
                      </p>
                    </div>
                  )}
                </div>
                <hr />
                <div className="d-flex">
                  <Button
                    color="secondary"
                    style={{ fontSize: "13px" }}
                    onClick={() => {
                      toggleStep("3");
                    }}
                  >
                    Kthehu pas
                  </Button>
                  <Button
                    className="ml-auto"
                    color="primary"
                    style={{ fontSize: "13px" }}
                    onClick={() => onDelete()}
                  >
                    Rifillo
                  </Button>
                </div>
              </TabPane>
            </TabContent>
          </Col>
        </Row>
      </CardBody>
    </Card>
  );
}

export default Form;
